// in src/CookieConsent/CloneCookieConsent.js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import FileCopyIcon from '@material-ui/icons/FileCopy';

class CloneCookieConsent extends Component {

    handleClick = () => {
        let record = this.props.record;

        for (const property in record) {
            if(`${property}` === '@id' || `${property}` === '@type') {
                delete record[property];
            }
        }

        let source = encodeURIComponent(JSON.stringify(record));
        window.location.replace(`#/cookie-consents/create?source=${source}`);
    }

    render() {
        return <Button variant="text" color="primary" size="small" onClick={this.handleClick}>
        <FileCopyIcon /> &nbsp; Copy
        </Button>;
    }
}

CloneCookieConsent.propTypes = {
    record: PropTypes.object,
};

export default connect(null, null)(CloneCookieConsent);